import { z } from 'zod'
import type { CustomRole } from '@fintree/supabase/roles'

export const addStaffSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z.string().email('Valid email required'),
  customRoleId: z.string().min(1, 'Role is required'),
})

export type AddStaffForm = z.infer<typeof addStaffSchema>

export const roleFormSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  description: z.string().optional(),
  permissions: z.array(z.string()),
})

export type RoleFormValues = z.infer<typeof roleFormSchema>

export const GROUP_ORDER = ['General', 'Students', 'Placements', 'Support', 'Analytics', 'Content', 'Admin'] as const

export function resolveStaffRoleSelectValue(
  row: { custom_role_id: string | null; role: string },
  roles: CustomRole[]
): string {
  if (row.custom_role_id) return row.custom_role_id
  return roles.find((r) => r.name === row.role)?.id ?? ''
}
